import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit,  } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ITermsOfUseContent } from '@shared/interfaces/terms-of-use-content';
import { ApiService } from '@shared/services/api.service';
import { StorageService } from '@shared/services/storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyPolicyModalComponent implements OnInit {
  termsOfUseContent: string = "";
  idLanguage = JSON.parse(this.storage.getStorage(this.storage.idLanguage)) ?? "en";
  lpLanguage = JSON.parse(this.storage.getStorage(this.storage.lpLanguage)) ?? "en";
  language = this.idLanguage ? this.idLanguage : this.lpLanguage;
  loading = true;

  private subscription = new Subscription();

  constructor(
    protected dialogRef: NbDialogRef<PrivacyPolicyModalComponent>,
    private api: ApiService,
    private storage: StorageService,
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.api.getTermOfUseContent(this.language).subscribe(res => {
        this.termsOfUseContent = (res as ITermsOfUseContent).content;
        this.loading = false;
        this.ref.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  close(): void {
    this.api.patchAcceptPrivacyPolicy().subscribe();
    this.dialogRef.close();
  }
}
